export const openDownloadDialog = {
    type: 'OPEN_DOWNLOAD_DIALOG',
};

export const closeDownloadDialog = {
    type: 'CLOSE_DOWNLOAD_DIALOG',
};
